import { render, staticRenderFns } from "./AppNewInformationRequest.vue?vue&type=template&id=749c31bb&scoped=true"
import script from "./AppNewInformationRequest.vue?vue&type=script&lang=js"
export * from "./AppNewInformationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c31bb",
  null
  
)

export default component.exports